import client from "../libs/HttpClient";

class NewsLetterServices {
  static newsletterList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/newsletter?page=${page_no}`, request);
  }
  static addNewsLetter(request) {
    return client.post(`/add-newsletter`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static updateNewsLetter(request) {
    return client.post(`/update-newsletter`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static viewNewsLetter(params) {
    return client.get(`get-newsletter`, { params });
  }
  static deleteNewsLetter(params) {
    return client.delete(`delete-newsletter`, { params });
  }
}
export { NewsLetterServices };
